import $ from "jquery";

$(() => {
  const postsBlock = $(".posts");
  if (postsBlock.length > 0) {
    const params = {};
    let hash;
    const hashes = decodeURIComponent(
      window.location.search
        .substring(1)
        .replace(/%5B[0-9]+%5D/g, "")
        .replace(/\+/g, "%20")
    ).split("&");

    hashes.forEach(item => {
      hash = item.split("=");
      if (hash[1]) {
        if (hash[0] === "type") {
          if (params[hash[0]]) {
            params[hash[0]].push(hash[1]);
          } else {
            params[hash[0]] = [hash[1]];
          }
        } else {
          params[hash[0]] = hash[1];
        }
      }
    });

    const renderPaginationArrows = () => {
      if (
        document.querySelector(".next.page-numbers") &&
        !document
          .querySelector(".next.page-numbers")
          .innerHTML.includes("custom-next-button")
      ) {
        document.querySelector(
          ".next.page-numbers"
        ).innerHTML = `<svg class="custom-next-button" width="16" height="12" viewBox="0 0 16 12" xmlns="http://www.w3.org/2000/svg">
                                                                        <g id="arrow-right-circle">
                                                                        <path id="Path" d="M10.333 1L14.9997 5.66667L10.333 10.3333" stroke-width="1.55556" stroke-linecap="round" stroke-linejoin="round"/>
                                                                        <path id="Path_2" d="M1 5.66669H12.6667" stroke-width="1.55556" stroke-linecap="round" stroke-linejoin="round"/>
                                                                        <path id="Path_3" d="M15.0003 5.66669H12.667" stroke-width="1.55556" stroke-linecap="round" stroke-linejoin="round"/>
                                                                        </g>
                                                                    </svg>`;
      }

      if (
        document.querySelector(".prev.page-numbers") &&
        !document
          .querySelector(".prev.page-numbers")
          .innerHTML.includes("custom-back-button")
      ) {
        document.querySelector(
          ".prev.page-numbers"
        ).innerHTML = `<svg style="transform: rotate(180deg)" class="custom-back-button" width="16" height="12" viewBox="0 0 16 12" xmlns="http://www.w3.org/2000/svg">
                                                                        <g id="arrow-right-circle">
                                                                        <path id="Path" d="M10.333 1L14.9997 5.66667L10.333 10.3333" stroke-width="1.55556" stroke-linecap="round" stroke-linejoin="round"/>
                                                                        <path id="Path_2" d="M1 5.66669H12.6667" stroke-width="1.55556" stroke-linecap="round" stroke-linejoin="round"/>
                                                                        <path id="Path_3" d="M15.0003 5.66669H12.667" stroke-width="1.55556" stroke-linecap="round" stroke-linejoin="round"/>
                                                                        </g>
                                                                    </svg>`;
      }
    };

    const fetchPosts = (type, paged) => {
      const jsonData = { paged: paged };

      if (type) {
        jsonData.type = type;
      }

      const data = {
        action: "filter_projects",
        json: JSON.stringify(jsonData)
      };

      $.ajax({
        type: "POST",
        url: "/wp/wp-admin/admin-ajax.php",
        dataType: "json",

        data: data,
        success: function(res) {
          console.log(res);
          $(".posts .posts-items").html(res.items);
          $(".posts .pagination").html(res.pagination);

          renderPaginationArrows();

          window.history.replaceState(null, null, "?" + res.params);

          // renderFilterQuantity()
        }
      });
    };

    fetchPosts(params.type, $(".posts").data("paged"));

    if (params.type) {
      const button = $(
        ".posts .categories .category[data-category='" + params.type + "']"
      );
      const text = button.text();
      $(".posts .categories .category").removeClass("active");
      button.addClass("active");
      $(".posts .categories .dropdown span").text(text);
    }

    $(".posts .categories .category").on("click", ({ currentTarget }) => {
      const pathname = window.location.pathname.substring(
        0,
        window.location.pathname.indexOf("/page")
      );
      history.pushState(null, null, pathname);
      const elem = $(currentTarget);
      const type = elem.data("category");
      const text = elem.text();

      $(".posts .categories .category").removeClass("active");
      elem.addClass("active");
      $(".posts .categories .dropdown span").text(text);
      $(".posts .categories .dropdown-content").removeClass("open");
      fetchPosts(type, 1);
    });

    $(".posts .categories .dropdown").on("click", () => {
      $(".posts .categories .dropdown-content").toggleClass("open");
    });
  }
});
